import { ArrowDownTrayIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export default function DSEATool() {
  return (
    <div>
      <div>
        <h5>
          <img src="/static/images/icons/iconsPink/dna.svg" alt="R package" className="inline w-8 h-8 mr-2" />
          DISGENET Score Enrichment Analysis
        </h5>
        <p>
          Performs Gene Set Enrichment Analysis (GSEA) to identify diseases whose associated genes are
          significantly enriched in the input gene list.
        </p>
      </div>

      <div className="divider"></div>
      <div className="mt-4">
        <h5 className="row">
          <img
            src="/static/images/icons/iconsPink/calculator.svg"
            alt="calculator"
            className="w-6 h-6 mr-2"
          />
          Method
        </h5>
        <p>
          For each candidate disease, genes are ranked by the DISGENET gene-disease association score
          (score_gda). The enrichment score (ES) is computed using the running-sum statistic described by
          Subramanian et al. (PNAS, 2005). Both the classic unweighted GSEA (exponent = 0) and the weighted
          GSEA (exponent &gt; 0) are supported.
        </p>
      </div>
      <div className="divider"></div>
      <div className="mt-4">
        <h5 className="row">
          <img
            src="/static/images/icons/iconsPink/calculator.svg"
            alt="calculator"
            className="w-6 h-6 mr-2"
          />
          Statistics returned
        </h5>
        <ul>
          <li className="bullet-item">
            <strong>ES (Enrichment Score):</strong>
          </li>
          <p className="ml-6">Maximum deviation of the running enrichment statistic from zero.</p>
          <li className="bullet-item">
            <strong>NES (Normalized Enrichment Score):</strong>
          </li>
          <p className="ml-6">enrichment score normalized using permutation analysis.</p>
          <li className="bullet-item">
            <strong>P-value:</strong>
          </li>
          <p className="ml-6">empirical significance estimated by permutation testing.</p>
          <li className="bullet-item">
            <strong>FDR q-value:</strong>
          </li>
          <p className="ml-6">false discovery rate adjusted p-value.</p>
          <li className="bullet-item">
            <strong>Leading edge:</strong>
          </li>
          <p className="ml-6">subset of query genes contributing most to the enrichment signal.</p>
          <li className="bullet-item">
            <strong>Running score:</strong>
          </li>
          <p className="ml-6">complete running enrichment trace across the ranked disease gene list.</p>
        </ul>
      </div>
      <div className="divider"></div>
      <div className="mt-4">
        <h5 className="row">
          <ArrowDownTrayIcon className="w-5 h-5 mr-2 text-pink" />
          Input requirements
        </h5>
        <ul>
          <li className="bullet-item">
            Provide at least one gene identifier list (NCBI Gene IDs, Ensembl IDs, HGNC symbols or UniProt
            IDs). Each list accepts up to 1000 identifiers separated by commas.
          </li>
          <li className="bullet-item">
            Optional parameters:
            <ul>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                source
              </li>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                minScore / maxScore
              </li>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                exponent
              </li>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                minCommonGenes
              </li>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                minGeneSetSize / maxGeneSetSize
              </li>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                minHits
              </li>
              <li>
                <ChevronRightIcon className="w-4 h-4 inline-block mr-1 text-pink" />
                nPermutations
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}
